module.exports = __webpack_public_path__ + "img/movil.9ff4b119.png";